import React from 'react';
import { Button, Space, notification } from 'antd';
import { CheckCircleFilled } from '@ant-design/icons';

export interface ActionFeedbackButton {
  label: string;
  onClick: () => void;
}

export interface ActionFeedbackOptions {
  title: string;
  buttons?: ActionFeedbackButton[];
  duration?: number;
  placement?: 'topLeft' | 'topRight' | 'bottomLeft' | 'bottomRight';
  onClose?: () => void;
}

export const showActionFeedback = (options: ActionFeedbackOptions): void => {
  const key = `action-feedback-${Date.now()}-${Math.random().toString(16).slice(2)}`;

  notification.open({
    key,
    message: options.title,
    placement: options.placement || 'topRight',
    duration: options.duration ?? 3,
    icon: <CheckCircleFilled style={{ color: '#52c41a' }} />,
    onClose: options.onClose,
    btn: options.buttons?.length ? (
      <Space>
        {options.buttons.map((b) => (
          <Button
            key={b.label}
            type="link"
            size="small"
            onClick={() => {
              b.onClick();
              notification.destroy(key);
            }}
          >
            {b.label}
          </Button>
        ))}
        <Button type="link" size="small" onClick={() => notification.destroy(key)}>
          取消
        </Button>
      </Space>
    ) : (
      <Button type="link" size="small" onClick={() => notification.destroy(key)}>
        取消
      </Button>
    ),
  });
};
